module.exports = __webpack_public_path__ + "img/01-T.813e2e9a.png";